import React from 'react'
import { View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { StyleService, useStyleSheet } from '@src/style/service'
import { Button, Icon, Text } from '@components/base'
import { AppStackParamList } from '@src/navigation/types'
import { useIsDarkMode } from '@src/config/theme'
import { palette } from '@src/style/palette'

export const UploadLabResultsSuccessScreen = () => {
  const styles = useStyleSheet(themedStyles)
  const insets = useSafeAreaInsets()
  const navigation = useNavigation<StackNavigationProp<AppStackParamList>>()
  const isDarkMode = useIsDarkMode()
  const hourglassColor = isDarkMode ? palette.dark.tooltip.surface : palette.swamp

  return (
    <View style={[styles.container, { paddingTop: insets.top, paddingBottom: insets.bottom + 16 }]}>
      <View style={styles.contentContainer}>
        <Icon
          name="hourglass-simple-medium"
          style={[styles.hourglassIcon, { color: hourglassColor }]}
        />
        <Text type="title-2" style={styles.headerText}>
          We're processing your lab results
        </Text>
        <Text type="regular" style={styles.bodyText}>
          We'll notify you once it's ready to view. This usually takes less than a minute.
        </Text>
      </View>
      <View style={{ flex: 1, justifyContent: 'flex-end' }}>
        <Button
          type="outline"
          size="block"
          onPress={() => {
            navigation.replace('LabResultsScreen')
          }}
          accessibilityLabel="Confirm"
        >
          Done
        </Button>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    flex: 1,
    padding: 16,
  },
  contentContainer: {
    alignItems: 'center',
  },
  hourglassIcon: {
    width: 96,
    height: 96,
    marginTop: 88,
    color: 'theme.tooltip.surface',
  },
  headerText: {
    marginTop: 24,
    marginBottom: 24,
    marginHorizontal: 80,
    textAlign: 'center',
  },
  bodyText: {
    marginBottom: 16,
    paddingHorizontal: 20,
    textAlign: 'center',
  },
  doneButton: {
    marginBottom: 16,
  },
})
